import React, { FC } from "react";
import { ExtendedProjectInfoDc, ResourceTypeLink, ServiceInfoDc, TableInfoDc } from "@evergis/api";

import { LayerCard } from "./LayerCard";
import { ProjectCard } from "./ProjectCard";
import { TableCard } from "./TableCard";

import { useResourceType } from "../../../../hooks/useResourceType";

import { ResourceInfoDc } from "../../types";

export interface CardProps<R extends ResourceInfoDc = ResourceInfoDc> {
  resource: R;
}

export const isProjectResource = (
  resource: ResourceInfoDc,
  resourceType: ResourceTypeLink,
): resource is ExtendedProjectInfoDc => resourceType === ResourceTypeLink.Project;

export const isLayerResource = (resource: ResourceInfoDc, resourceType: ResourceTypeLink): resource is ServiceInfoDc =>
  resourceType === ResourceTypeLink.Layer;

export const isTableResource = (resource: ResourceInfoDc, resourceType: ResourceTypeLink): resource is TableInfoDc =>
  resourceType === ResourceTypeLink.Table;

export const Card: FC<CardProps> = ({ resource }) => {
  const [resourceType] = useResourceType();

  if (isProjectResource(resource, resourceType)) {
    return <ProjectCard resource={resource} />;
  }

  if (isLayerResource(resource, resourceType)) {
    return <LayerCard resource={resource} />;
  }

  if (isTableResource(resource, resourceType)) {
    return <TableCard resource={resource} />;
  }

  return null;
};
